/* Spanish catalog mirroring locale-sales-payments-customers-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'inv.unknownAccount': 'Cuenta desconocida',
  'inv.refund.customerBalance': "Saldo a favor del cliente",
  'inv.refund.balanceHelp': "El saldo incluye las notas de crédito y los pagos y reembolsos que se detallan a continuación.",
  'inv.refund.addFee': "Añadir comisión",
  'inv.refund.businessFee': "Comisión pagada por la empresa",
  'inv.refund.customerReceives': "El cliente recibe",
  'inv.refund.accountDebit': "Cargo total en la cuenta",
  'sale.pay.ownerDebt': "Deuda a corto plazo con los propietarios",
  'sale.pay.title': 'Pago',
  'sale.pay.help': 'Elige en qué cuenta y en qué fecha se cobró la venta. Añade una comisión o divide el pago en varios pagos parciales. El total debe coincidir con las líneas de la venta.',
  'sale.pay.paidTo': 'Pagado en',
  'sale.pay.choosePaymentAccount': 'Elegir cuenta de pago',
  'sale.create.needPaymentAccount': 'Elige «Pagado en» antes de contabilizar la venta.',
  'sale.pay.paidDate': 'Fecha de pago',
  'sale.pay.fee': 'Comisión',
  'sale.pay.addFee': 'Añadir comisión',
  'sale.pay.removeFee': 'Quitar comisión',
  'sale.pay.partial': 'Pagos parciales',
  'sale.pay.addPartial': 'Añadir pago parcial',
  'sale.pay.removePartial': 'Quitar pago parcial',
  'sale.pay.seeTransaction': 'Ver movimiento',
  'sale.pay.addAccount': 'Añadir cuenta',
  'sale.pay.addCard': 'Añadir tarjeta de crédito',
  'sale.pay.addBankTitle': 'Añadir cuenta bancaria',
  'sale.pay.addCardTitle': 'Añadir tarjeta de crédito',
  'sale.pay.addSolutionTitle': 'Añadir solución de pago',
  'sale.pay.solution': 'Solución de pago',
  'sale.pay.accountType': 'Tipo de cuenta',
  'sale.pay.cardOwner': 'La tarjeta pertenece a',
  'sale.pay.displayName': 'Nombre visible (opcional)',
  'sale.pay.orgNumber': 'N.º de empresa',
  'sale.pay.openingBalance': 'Saldo inicial para la conciliación',
  'sale.pay.openingBalanceDate': 'Fecha del saldo inicial',
  'sale.pay.resetChoice': 'Borrar selección',
  'sale.cust.helpTitle': 'Cliente de la venta',
  'sale.cust.help': 'Elige a quién va dirigida la venta. Busca un cliente, una lista o una suscripción guardados, o pulsa «Nuevo cliente» para introducir un destinatario que aún no esté guardado. El nombre y la dirección se incorporan automáticamente al documento.',
  'sale.cust.optionalHelp': 'El cliente es opcional en otras ventas. Actívalo si quieres vincular la venta a un cliente concreto.',
  'sale.cust.search': 'Buscar clientes, listas y suscripciones...',
  'sale.cust.pickExisting': 'Elegir existente',
  'sale.cust.new': 'Nuevo cliente',
  'sale.cust.add': 'Añadir cliente',
  'sale.cust.selected': 'Cliente seleccionado',
  'sale.cust.selectedList': 'Lista de destinatarios seleccionada',
  'sale.cust.none': 'Aún no hay ningún cliente seleccionado',
  'sale.cust.listsAndSubs': 'Listas y suscripciones',
  'sale.cust.detailsTitle': 'Datos del cliente',
  'sale.cust.name': 'Nombre del cliente',
  'sale.cust.namePh': 'P. ej. Ejemplo S.L.',
  'sale.cust.number': 'N.º de cliente',
  'sale.cust.org': 'N.º de empresa',
  'sale.cust.orgPh': '123 456 789',
  'sale.cust.address': 'Dirección',
  'sale.cust.addressPh': 'Calle, código postal y localidad',
  'sale.cust.email': 'Correo electrónico',
  'sale.cust.emailPh': 'contacto@ejemplo.com',
  'sale.cust.phone': 'Teléfono',
  'sale.cust.phonePh': '400 00 000',
  'sale.cust.contacts': 'Personas de contacto',
  'sale.cust.noContacts': 'No se han añadido personas de contacto.',
  'sale.cust.addContact': 'Añadir persona de contacto',
  'sale.cust.removeContact': 'Quitar persona de contacto',
  'sale.cust.contactName': 'Nombre',
  'sale.cust.contactNamePh': 'P. ej. María García',
  'sale.cust.contactRole': 'Cargo',
  'sale.cust.contactRolePh': 'P. ej. Contabilidad',
  'sale.cust.outstanding': 'Pendiente',
  'sale.cust.revenueToDate': 'Ingresos hasta la fecha',
  'sale.cust.pickPh': 'Cliente o número',
  'sale.cust.select': 'Elegir cliente',
  'sale.cust.use': 'Usar cliente',
  'sale.cust.noEmail': 'El cliente no tiene correo electrónico',
  'sale.cust.listDefaultName': 'Lista de clientes',
  'sale.cust.updatedToast': 'Cliente actualizado en la venta',
  'sale.cust.noCustomerHelp': 'La venta se registra sin cliente. Activa el interruptor si quieres vincularla a un cliente.',
  'sale.cust.selectHint': 'Elige un cliente, una lista o una suscripción guardados, o usa «Nuevo cliente» para texto libre.',
  'sale.cust.recipientsCount': '{count} destinatarios',
  'sale.cust.kindSubscription': 'Suscripción',
  'sale.cust.kindList': 'Lista',
  'sale.cust.noMatches': 'Sin resultados para «{query}».',
  'sale.cust.addAsNew': 'Añadir «{query}» como nuevo cliente',
  'sale.cust.contactDefaultName': 'Persona de contacto {n}',
  'sale.cust.saveFailed': 'No se pudo guardar el cliente.',
  'sale.pay.accountNameSavings': 'Cuenta de ahorro',
  'sale.pay.accountNameOperating': 'Cuenta corriente de la empresa',
  'sale.pay.accountNamePrivate': 'Cuenta privada',
  'sale.pay.accountNameBank': 'Cuenta bancaria',
  'sale.pay.groupBank': 'Cuentas bancarias',
  'sale.pay.groupCard': 'Tarjetas de crédito',
  'sale.pay.groupPrivate': 'Privado',
  'sale.pay.groupOther': 'Otro',
  'sale.pay.groupGeneric': 'Cuentas',
  'sale.pay.cashLabel': 'Efectivo',
  'sale.pay.bankNameRequired': 'Ponle un nombre a la cuenta bancaria',
  'sale.pay.accountOrCardNameRequired': 'Ponle un nombre a la cuenta o a la tarjeta',
  'sale.pay.accountNumberRequired': 'Introduce el número de cuenta',
  'sale.pay.bankAccountAdded': 'Cuenta bancaria añadida',
  'sale.pay.privateAccountAdded': 'Cuenta privada añadida',
  'sale.pay.saveAccountFailed': 'No se pudo guardar la cuenta.',
  'sale.pay.accountsUnavailable': 'Las cuentas de pago no están conectadas al backend.',
  'sale.pay.openingSetupRequired': 'Introduce la fecha de inicio y el saldo inicial. Introduce 0 si el saldo era cero.',
  'sale.pay.invalidLedgerAccount': 'Falta un número de cuenta válido en el plan de cuentas.',
  'sale.pay.accountExists': 'La cuenta {code} ya existe.',
  'sale.pay.typePrivateCard': 'Cuenta privada / tarjeta',
  'sale.pay.newBankAccountNote': 'Se crea una nueva cuenta bancaria en el plan de cuentas',
  'sale.pay.newPrivateAccountNote': 'Se crea una nueva cuenta privada/tarjeta en el plan de cuentas',
  'sale.pay.bankAccountSeriesInfo': 'Las cuentas bancarias reciben la siguiente cuenta libre de la serie 192x.',
  'sale.pay.privateAccountSeriesInfo': 'Las tarjetas/cuentas privadas reciben la siguiente cuenta puente libre de la serie 206x.',
  'sale.pay.thisGetsAccount': 'Cuenta asignada',
  'sale.pay.accountNameLabel': 'Nombre de la cuenta',
  'sale.pay.accountOrCardNameLabel': 'Nombre de la cuenta / tarjeta',
  'sale.pay.accountNamePhBank': 'P. ej. Cuenta corriente 2',
  'sale.pay.accountNamePhPrivate': 'P. ej. Tarjeta del propietario Visa',
  'sale.pay.accountNumberLabel': 'Número de cuenta',
  'sale.pay.accountCardRefLabel': 'Cuenta / número de tarjeta / referencia (opcional)',
  'sale.pay.interimAccountPrefix': 'Cuenta puente',
  'sale.pay.cardNameRequired': 'Ponle un nombre a la tarjeta de crédito',
  'sale.pay.cardNumberRequired': 'Introduce el número de tarjeta/cuenta',
  'sale.pay.openingBalanceRequired': 'Introduce el saldo inicial y su fecha',
  'sale.pay.creditCardDebtPrefix': 'Deuda de tarjeta de crédito',
  'sale.pay.cardAdded': 'Tarjeta de crédito añadida',
  'sale.pay.saveCardFailed': 'No se pudo guardar la tarjeta de crédito.',
  'sale.pay.scopeBusiness': 'Empresa',
  'sale.pay.businessCardNote': 'Las tarjetas de empresa se contabilizan como una deuda de tarjeta independiente',
  'sale.pay.privateCardNote': 'Las tarjetas privadas se contabilizan en una cuenta puente',
  'sale.pay.businessCardSeriesInfo': 'Las tarjetas de empresa que no son cuentas bancarias reciben la siguiente cuenta libre de la serie 238x.',
  'sale.pay.privateCardSeriesInfo': 'Las tarjetas privadas reciben la siguiente cuenta puente libre de la serie 206x.',
  'sale.pay.accountInLedger': 'Cuenta en contabilidad:',
  'sale.pay.cardNamePhBusiness': 'P. ej. Tarjeta de empresa Visa',
  'sale.pay.cardNamePhPrivate': 'P. ej. Tarjeta del propietario Mastercard',
  'sale.pay.cardNumberLabel': 'Número de tarjeta / de cuenta',
  'sale.pay.cardNumberLabelOptional': 'Número de tarjeta / de cuenta (opcional)',
  'sale.pay.otherSolution': 'Otra solución de pago',
  'sale.pay.settlementPrefix': 'Liquidación',
  'sale.pay.solutionAdded': 'Solución de pago añadida',
  'sale.pay.saveSolutionFailed': 'No se pudo guardar la solución de pago.',
  'sale.pay.solutionExplainer': 'Vipps, PayPal, iZettle, Stripe y similares se contabilizan en una cuenta de liquidación propia de la solución de pago, que se concilia cuando la liquidación se ingresa en la cuenta bancaria.',
  'sale.pay.addCardAction': '+ Añadir tarjeta de crédito ...',
  'sale.pay.addSolutionAction': '+ Añadir solución de pago ...',
  'sale.pay.partialLabel': 'Pago parcial {n}',
  'sale.pay.partialStatusRemaining': 'restante',
  'sale.pay.partialStatusTooMuch': 'de más',
  'sale.pay.partialStatusMatches': 'coincide',
  'sale.pay.partialSummary': 'Pagado {paid} de {expected} · {status}',
  'sale.pay.partialMismatch': 'La suma de los pagos parciales debe coincidir con el total de la venta{feeSuffix} ({expected}).',
  'sale.list.noMembers': 'La lista no tiene clientes a los que facturar.',
  'sale.list.customerMissing': 'El cliente ya no existe.',
  'sale.list.noneCreated': 'No se creó ninguna factura.',
  'sale.list.missingEmailNotice': 'Se crearon {count} facturas para clientes sin correo electrónico; deben enviarse o imprimirse manualmente: {names}',
  'sale.list.notCreatedNotice': 'No completado para: {names}',
  'sale.list.createdNoEmail': 'La factura se creó, pero el cliente no tiene correo electrónico. Envíala o imprímela manualmente.',
  'sale.list.noneSent': 'Las facturas se crearon, pero ninguna se envió por correo electrónico. Envíalas o imprímelas manualmente: {names}',
  'sale.list.recipientsCount': '{count} destinatarios',
  'sale.list.sentPartly': 'Enviado a {sent} destinatarios. No enviado: {names}',
  'sale.list.sentAll': 'Enviado a {sent} destinatarios.',
  'sale.pay.partialMismatchFeeSuffix': ' menos la comisión',
  'sale.pay.feeTooHigh': 'La comisión no puede ser mayor que el importe de la venta ({gross}).',
  'sale.pay.splitMismatchError': 'Los pagos parciales ({paid}) deben sumar el total de la venta menos la comisión ({expected}).',
  'sale.product.backendUnavailable': 'El guardado de productos no está conectado al backend.',
  'sale.product.added': 'Producto «{name}» añadido',
  'sale.product.updated': 'Producto «{name}» actualizado',
  'sale.product.saveFailed': 'No se pudo guardar el producto.',
  'sale.create.backendUnavailable': 'La nueva venta no está conectada al backend.',
});
